<template>
  <b-container fluid>
    <!-- Search Form -->
      <iq-card>
            <template v-slot:headerTitle>
                <h4 class="card-title">{{ $t('billing_info.billing_info') }} {{ $t('globalTrans.search') }}</h4>
            </template>
            <template v-slot:body>
            <b-row>
  <b-col lg="3" sm="3">
    <ValidationProvider name="Area Type" vid="hos_area_type_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="hos_area_type_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro.area_type')}}
        </template>
        <b-form-select
          plain
          v-model="search.hos_area_type_id"
          id="hos_area_type_id"
          :options="getHosAreaTypeList"
          @change="getAreaTypeData(search.area_type_id)"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3">
    <ValidationProvider name="Division" vid="division_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="division_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('externalUser.division')}}
        </template>
        <b-form-select
          plain
          v-model="search.hos_division_id"
          id="division_id"
          :options="getHosDivisionList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3">
    <ValidationProvider name="District" vid="district_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="district_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro_district.district')}}
        </template>
        <b-form-select
          plain
          v-model="search.hos_district_id"
          id="district_id"
          :options="getHosDistrictList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3" v-if="search.hos_area_type_id > 1">
    <ValidationProvider name="Upazila" vid="upazila_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="upazila_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro_upazilla.upazilla')}}
        </template>
        <b-form-select
          plain
          v-model="search.hos_upazila_id"
          id="upazila_id"
          :options="getHosUpazillaList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="3" sm="3" v-if="search.hos_area_type_id === 1">
    <ValidationProvider name="City Corporation" vid="city_corporation_id">
        <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="city_corporation_id "
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{$t('org_pro.city_corporation')}}
        </template>
        <b-form-select
          plain
          v-model="search.hos_city_corporation_id"
          id="city_corporation_id"
          :options="getHosCityCorporationList"
          :state="errors[0] ? false : (valid ? true : null)"
        >
        <template v-slot:first>
        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
        </template>
        </b-form-select>
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
        </b-form-group>
    </ValidationProvider>
  </b-col>
  <b-col lg="6" sm="6">
    <ValidationProvider name="Hospital Name" vid="hospital_id">
      <b-form-group
        class="row"
        label-cols-sm="12"
        label-for="hospital_id"
        slot-scope="{ valid, errors }"
        >
        <template v-slot:label>
          {{ $t('hospital_configuration.hospital_name')}}
        </template>
        <v-select name="Bank"
            v-model="search.hospital_id"
            label="text"
            :reduce="item => item.value"
            :options= hospitalList
            @change="searchData()"
            :placeholder="$t('globalTrans.select')"
        />
        <div class="invalid-feedback">
          {{ errors[0] }}
        </div>
      </b-form-group>
    </ValidationProvider>
  </b-col>
                  <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                      <ValidationProvider name="year" vid="fiscal_year_id" rules="required|min_value:1">
                          <b-form-group
                              class="row"
                              label-cols-sm="12"
                              label-for="fiscal_year_id"
                              slot-scope="{ valid, errors }"
                          >
                          <template v-slot:label>
                              {{$t('externalUser.fiscal_year')}}<span class="text-danger">*</span>
                          </template>
                          <b-form-select
                              plain
                              v-model="search.fiscal_year_id"
                              :options="yearList"
                              id="fiscal_year_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                          >
                          <template v-slot:first>
                              <b-form-select-option disabled :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                          </template>
                          </b-form-select>
                          <div class="invalid-feedback">
                              {{ errors[0] }}
                          </div>
                          </b-form-group>
                      </ValidationProvider>
                  </b-col>
                  <b-col xs="12" sm="12" md="3" lg="3" xl="3">
                        <ValidationProvider name="Month" vid="month_id" rules="required|min_value:1">
                        <b-form-group
                            class="row"
                            label-cols-sm="12"
                            label-for="month_id"
                            slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                            {{$t('production_store.month')}}<span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="search.month_id"
                            :options="monthList"
                            id="month_id"
                            :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                            <b-form-select-option disabled :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                            {{ errors[0] }}
                        </div>
                        </b-form-group>
                        </ValidationProvider>
                    </b-col>
            <b-col class="text-right">
              <b-button type="button" variant="primary" @click="searchData">
                {{ $t('globalTrans.search')}}
              </b-button>
            </b-col>
                </b-row>
            </template>
      </iq-card>
        <iq-card v-if="search.hospital_id === 0">
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('billing_info.billing_info_list')}}</h4>
          </template>
          <template v-slot:body>
            <b-col class="text-right">
            <b-button @click="pdfExport" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
            </b-col>
            <b-overlay :show="loadingState">
                  <b-table-simple bordered>
                    <b-tr>
                        <b-th colspan="11">{{$t('billing_info.billing_info_report')}} <span v-if="search.month_id > 0">{{ getMonthName(search.month_id) }}, </span><span v-if="search.fiscal_year_id > 0">{{ getYearName(search.fiscal_year_id) }}</span><span v-else> {{$t('billing_info.all')}} </span> {{$t('billing_info.billing_info_report_month')}}</b-th>
                    </b-tr>
                    <b-tr>
                        <b-th rowspan="2">{{$t('globalTrans.sl_no')}}</b-th>
                        <b-th rowspan="2">{{$t('billing_info.hospital_name')}}</b-th>
                        <b-th colspan="3">{{$t('billing_info.tot_patient')}}</b-th>
                        <b-th colspan="3">{{$t('billing_info.free_treatment')}}</b-th>
                        <b-th colspan="3">{{$t('billing_info.percentage')}}</b-th>
                    </b-tr>
                    <b-tr>
                        <b-th>{{$t('globalTrans.male')}}</b-th>
                        <b-th>{{$t('globalTrans.female')}}</b-th>
                        <b-th>{{$t('globalTrans.total')}}</b-th>
                        <b-th>{{$t('globalTrans.male')}}</b-th>
                        <b-th>{{$t('globalTrans.female')}}</b-th>
                        <b-th>{{$t('globalTrans.total')}}</b-th>
                        <b-th>{{$t('globalTrans.male')}}</b-th>
                        <b-th>{{$t('globalTrans.female')}}</b-th>
                        <b-th>{{$t('globalTrans.total')}}</b-th>
                    </b-tr>
                    <b-tr v-for="(item, index) in hospitalAllList" :key="index">
                      <b-th>{{ $n(index+1) }}</b-th>
                      <b-th v-if="item.value">{{ getHospitalName(parseInt(item.value))}}</b-th>
                        <b-th v-if="item.value">{{ $n(getTMaleCount(parseInt(item.value)), { useGrouping: false })}}</b-th>
                        <b-th v-if="item.value">{{ $n(getTFemaleCount(parseInt(item.value)), { useGrouping: false })}}</b-th>
                        <b-th v-if="item.value">{{ $n(getTTotalCount(parseInt(item.value)), { useGrouping: false }) }}</b-th>
                      <b-th v-if="item.value">{{ $n(getMaleCount(parseInt(item.value)), { useGrouping: false })}}</b-th>
                      <b-th v-if="item.value">{{ $n(getFemaleCount(parseInt(item.value)), { useGrouping: false })}}</b-th>
                      <b-th v-if="item.value">{{ $n(getTotalCount(parseInt(item.value)), { useGrouping: false }) }}</b-th>
                          <b-th v-if="item.value">{{ $n(getPMaleCount(parseInt(item.value)), { useGrouping: false })}}</b-th>
                          <b-th v-if="item.value">{{ $n(getPFemaleCount(parseInt(item.value)), { useGrouping: false })}}</b-th>
                          <b-th v-if="item.value">{{ $n(getPTotalCount(parseInt(item.value)), { useGrouping: false }) }}</b-th>
                    </b-tr>
                    <!--<b-tr v-for="(item, index) in allData" :key="index">
                        <b-th>{{ $n(index+1) }}</b-th>
                        <b-th v-if="item.hospital_id">{{ getHospitalName(parseInt(item.hospital_id))}}</b-th>
                        <b-th >{{ $n(parseInt(item.man), { useGrouping: false }) }}</b-th>
                        <b-th >{{ $n(parseInt(item.women), { useGrouping: false }) }}</b-th>
                        <b-th >{{ $n(parseInt(item.man) + parseInt(item.women), { useGrouping: false }) }}</b-th>
                    </b-tr>-->
                  </b-table-simple>
            </b-overlay>
          </template>
        </iq-card>
        <iq-card v-else>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('billing_info.billing_info_list')}}</h4>
          </template>
          <template v-slot:body>
            <b-col class="text-right">
            <b-button @click="pdfExport2" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
            </b-col>
            <b-overlay :show="loadingState">
              <span hidden>
                {{ t_p_patient = 0 }}
                {{ t_p_amount = 0 }}
                {{ t_p_f_patient = 0 }}
                {{ t_p_f_amount = 0 }}
                {{ total_p = 0 }}
                {{ total_a = 0 }}
                {{ gt_p_patient = 0 }}
                {{ gt_p_amount = 0 }}
                {{ gt_p_f_patient = 0 }}
                {{ gt_p_f_amount = 0 }}
                {{ g_total_p = 0 }}
                {{ g_total_a = 0 }}
              </span>
            <b-col md=12  v-for="(value2,index) in allData2" :key="index">
            <h4>{{$t('globalTrans.form')}} - {{$n(index+1)}}</h4>
            <h5 v-if="value2.hospital_id">{{$t('billing_info.hospital_name')}} : {{getHospitalName(value2.hospital_id)}}</h5>
            <h5 v-if="value2.department_id">{{$t('hospital_configuration.department')}} : {{getDepartmentName(value2.department_id)}}</h5>
              <b-table-simple bordered>
                <b-tr>
                    <b-td colspan="3">{{ $t('billing_info.tot_patient') }}</b-td>
                    <b-td colspan="3">{{ $t('billing_info.free_treatment') }}</b-td>
                    <b-td colspan="3">{{ $t('billing_info.percentage') }}</b-td>
                    <b-td>{{ $t('billing_info.coment') }}</b-td>
                </b-tr>
                <b-tr>
                    <b-td colspan="2">{{$t('billing_info.patient_no')}}</b-td>
                    <b-td >{{$t('billing_info.fin')}}</b-td>
                    <b-td colspan="2">{{$t('billing_info.patient_no')}}</b-td>
                    <b-td >{{$t('billing_info.fin')}}</b-td>
                    <b-td colspan="2">{{$t('billing_info.patient_no')}}</b-td>
                    <b-td >{{$t('billing_info.fin')}}</b-td>
                    <b-td ></b-td>
                </b-tr>
                <b-tr>
                    <b-td >{{$t('billing_info.male')}}</b-td>
                    <b-td >{{ $n(parseInt(value2.tman)) }}</b-td>
                    <b-td >{{ $n(parseInt(value2.tmanA)) }}</b-td>
                    <b-td >{{$t('billing_info.male')}}</b-td>
                    <b-td >{{ $n(parseInt(value2.man)) }}</b-td>
                    <b-td >{{ $n(parseInt(value2.manA)) }}</b-td>
                    <b-td >{{$t('billing_info.male')}}</b-td>
                    <b-td >{{ $n(parseInt(value2.pman)) }}</b-td>
                    <b-td >{{ $n(parseInt(value2.pmanA)) }}</b-td>
                    <b-td >{{ value2.cf }}</b-td>
                </b-tr>
                <b-tr>
                    <b-td >{{$t('billing_info.female')}}</b-td>
                    <b-td >{{ $n(parseInt(value2.twomen)) }}</b-td>
                    <b-td >{{ $n(parseInt(value2.twomenA)) }}</b-td>
                    <b-td >{{$t('billing_info.female')}}</b-td>
                    <b-td >{{ $n(parseInt(value2.women)) }}</b-td>
                    <b-td >{{ $n(parseInt(value2.womenA)) }}</b-td>
                    <b-td >{{$t('billing_info.female')}}</b-td>
                    <b-td >{{ $n(parseInt(value2.pwomen)) }}</b-td>
                    <b-td >{{ $n(parseInt(value2.pwomenA)) }}</b-td>
                    <b-td >{{ value2.cl }}</b-td>
                </b-tr>
                <b-tr>
                  <span hidden>
                    {{ t_p_patient = (parseInt(value2.tman) + parseInt(value2.twomen)) ? (parseInt(value2.tman) + parseInt(value2.twomen)) : 0 }}
                    {{ t_p_amount = (parseInt(value2.tmanA) + parseInt(value2.twomenA)) ? (parseInt(value2.tmanA) + parseInt(value2.twomenA)) : 0 }}
                    {{ t_p_f_patient = (parseInt(value2.man) + parseInt(value2.women)) ? (parseInt(value2.man) + parseInt(value2.women)) : 0 }}
                    {{ t_p_f_amount = (parseInt(value2.manA) + parseInt(value2.womenA)) ? (parseInt(value2.manA) + parseInt(value2.womenA)) : 0 }}
                    {{ total_p = ((parseInt(t_p_f_patient) * 100) / parseInt(t_p_patient)) ? ((parseInt(t_p_f_patient) * 100) / parseInt(t_p_patient)) : 0 }}
                    {{ total_a = ((parseInt(t_p_f_amount) * 100) / parseInt(t_p_amount)) ? ((parseInt(t_p_f_amount) * 100) / parseInt(t_p_amount)) : 0 }}
                    {{ p_total_p = total_p }}
                    {{ p_total_a = total_a }}
                  </span>
                    <b-td >{{ $t('billing_info.total') }}</b-td>
                    <b-td >{{ $n(parseInt(value2.tman) + parseInt(value2.twomen)) }}</b-td>
                    <b-td >{{ $n(parseInt(value2.tmanA) + parseInt(value2.twomenA)) }}</b-td>
                    <b-td >{{ $t('billing_info.total') }}</b-td>
                    <b-td >{{ $n(parseInt(value2.man) + parseInt(value2.women)) }}</b-td>
                    <b-td >{{ $n(parseInt(value2.manA) + parseInt(value2.womenA)) }}</b-td>
                    <b-td >{{ $t('billing_info.total') }}</b-td>
                    <b-td >{{ $n(total_p) }}</b-td>
                    <b-td >{{ $n(total_a) }}</b-td>
                    <!-- <b-td >{{ $n(parseInt(value2.pwomenA) + parseInt(value2.pwomenA)) }}</b-td> -->
                    <b-td ></b-td>
                </b-tr>
                </b-table-simple>
            </b-col>
            <b-col md=12>
              <h4>{{$t('globalTrans.form')}} - {{$n(countIndex)}}</h4>
              <h5 >{{$t('billing_info.dept_treatment')}}</h5>
              <b-table-simple bordered>
                <b-tr>
                  <b-td colspan="3">{{ $t('billing_info.tot_patient') }}</b-td>
                  <b-td colspan="3">{{ $t('billing_info.free_treatment') }}</b-td>
                  <b-td colspan="3">{{ $t('billing_info.percentage') }}</b-td>
                  <b-td>{{ $t('billing_info.coment') }}</b-td>
                </b-tr>
                <b-tr>
                  <b-td colspan="2">{{$t('billing_info.patient_no')}}</b-td>
                  <b-td >{{$t('billing_info.fin')}}</b-td>
                  <b-td colspan="2">{{$t('billing_info.patient_no')}}</b-td>
                  <b-td >{{$t('billing_info.fin')}}</b-td>
                  <b-td colspan="2">{{$t('billing_info.patient_no')}}</b-td>
                  <b-td >{{$t('billing_info.fin')}}</b-td>
                  <b-td ></b-td>
                </b-tr>
                <b-tr>
                  <b-td >{{$t('billing_info.male')}}</b-td>
                  <b-td >{{ $n(tman()) }}</b-td>
                  <b-td >{{ $n(tmanA()) }}</b-td>
                  <b-td >{{$t('billing_info.male')}}</b-td>
                  <b-td >{{ $n(man()) }}</b-td>
                  <b-td >{{ $n(manA()) }}</b-td>
                  <b-td >{{$t('billing_info.male')}}</b-td>
                  <b-td >{{ $n(pman()) }}</b-td>
                  <b-td >{{ $n(pwomenA()) }}</b-td>
                  <b-td ></b-td>
                </b-tr>
                <b-tr>
                  <b-td >{{$t('billing_info.female')}}</b-td>
                  <b-td >{{ $n(twomen()) }}</b-td>
                  <b-td >{{ $n(twomenA()) }}</b-td>
                  <b-td >{{$t('billing_info.female')}}</b-td>
                  <b-td >{{ $n(women()) }}</b-td>
                  <b-td >{{ $n(womenA()) }}</b-td>
                  <b-td >{{$t('billing_info.female')}}</b-td>
                  <b-td >{{ $n(pwomen()) }}</b-td>
                  <b-td >{{ $n(pwomenA()) }}</b-td>
                <b-td ></b-td>
                </b-tr>
                <b-tr>
                  <span hidden>
                    {{ gt_p_patient = tman() + twomen() }}
                    {{ gt_p_amount = tmanA() + twomenA() }}
                    {{ gt_p_f_patient = man() + women() }}
                    {{ gt_p_f_amount = manA() + womenA() }}
                    {{ g_total_p = ((parseInt(gt_p_f_patient) * 100) / parseInt(gt_p_patient)) ? ((parseInt(gt_p_f_patient) * 100) / parseInt(gt_p_patient)) : 0 }}
                    {{ g_total_a = ((parseInt(gt_p_f_amount) * 100) / parseInt(gt_p_amount)) ? ((parseInt(gt_p_f_amount) * 100) / parseInt(gt_p_amount)) : 0 }}
                    {{ p_g_total_p = g_total_p }}
                    {{ p_g_total_a = g_total_a }}
                  </span>
                  <b-td >{{$t('billing_info.total')}}</b-td>
                  <b-td >{{ $n(tman() + twomen()) }}</b-td>
                  <b-td >{{ $n(tmanA() + twomenA()) }}</b-td>
                  <b-td >{{ $t('billing_info.total')}}</b-td>
                  <b-td >{{ $n(man() + women()) }}</b-td>
                  <b-td >{{ $n(manA() + womenA()) }}</b-td>
                  <b-td >{{ $t('billing_info.total')}}</b-td>
                  <!-- <b-td >{{ $n(pman() + pwomen()) }}</b-td>
                  <b-td >{{ $n(pmanA() + pwomenA()) }}</b-td> -->
                  <b-td >{{ $n(g_total_p) }}</b-td>
                  <b-td >{{ $n(g_total_a) }}</b-td>
                  <b-td ></b-td>
                </b-tr>
              </b-table-simple>
            </b-col>
            </b-overlay>
          </template>
        </iq-card>
  </b-container>
</template>
<script>
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { assignUserHospitalApi, billingReportApi, billingReportHospitalWiseApi } from '../../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import ExportPdf from './export-pdf'
import ExportPdf2 from './export-pdf-hos'

export default {
  mixins: [ModalBaseMasterList],
  components: {
  },
  data () {
    return {
      search: {
        hos_area_type_id: 0,
        hos_division_id: 0,
        hos_district_id: 0,
        hos_upazila_id: 0,
        hos_city_corporation_id: 0,
        hospital_id: '',
        billing_report_date: '',
        month_id: new Date().getMonth() + 1,
        fiscal_year_id: this.$store.state.currentFiscalYearId,
        reporting_month: ''
      },
      p_total_a: 0,
      p_total_p: 0,
      p_g_total_p: 0,
      p_g_total_a: 0,
      editItemId: '',
      countIndex: 0,
      rows: [],
      allData: [],
      allData2: [],
      hospitalIds: [],
      userId: 0,
      hospitalList: []
    }
  },
  computed: {
      currentLocale: function () {
          return this.$i18n.locale
      },
      yearList: function () {
        const data = this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
        const years = data.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
          } else {
            return { value: obj.value, text: obj.text_en }
          }
        })
        return years
      },
      monthList () {
        const objectData = this.$store.state.commonObj.monthList
        return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
          } else {
            return { value: obj.value, text: obj.text_en }
          }
        })
      },
      hospitalAllList: function () {
        return this.$store.state.HospitalDisabilityService.commonObj.hospitalThirtyPercentList.filter(item => item.is_jointly_formated === 1)
      },
      getHospitalCategoryList: function () {
        const objectData = this.$store.state.HospitalDisabilityService.commonObj.hospitalCategoryList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.id, text: obj.name_bn }
            } else {
                return { value: obj.id, text: obj.name }
            }
        })
      },
      getHosDivisionList: function () {
          return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
      },
      getHosDistrictList: function () {
          return this.$store.state.commonObj.districtList.filter(item => item.status === 0 && item.division_id === this.search.hos_division_id)
      },
      getHosCityCorporationList: function () {
          return this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === this.search.hos_district_id)
      },
      getHosUpazillaList: function () {
          return this.$store.state.commonObj.upazilaList.filter(item => item.status === 0 && item.district_id === this.search.hos_district_id)
      },
      getHosAreaTypeList: function () {
          const objectData = this.$store.state.commonObj.wardTypeList
          return objectData.map((obj, key) => {
              if (this.$i18n.locale === 'bn') {
                  return { value: obj.id, text: obj.name_bn }
              } else {
                  return { value: obj.id, text: obj.name }
              }
          })
      },
    billingInformationListApi: function () {
        return this.$store.state.ChildService.commonObj.billingInformationListApi.filter(item => item.status === 1)
    },
    formTitle () {
      return this.$t('billing_info.bill_repo_head')
    }
  },
  mounted () {
  },
  created () {
    this.hospital_id = 0
    // this.hospitalList = this.getHospitalList()
    // this.loadData()
    var officeId = this.$store.state.Auth.authUser.office_id
      if (officeId > 1) {
          this.userId = this.$store.state.Auth.authUser.user_id
          if (this.userId > 1) {
              this.getUserWiseHospital(this.userId)
          }
      } else {
          this.$store.state.HospitalDisabilityService.commonObj.hospitalThirtyPercentList.filter(item => item.status === 1).map((obj, key) => {
              this.hospitalIds.push(obj.value)
          })
          this.loadData()
          this.hospitalList = this.getHospitalList()
      }
  },
  watch: {
    currentLocale: function () {
        this.hospitalList = this.getHospitalList()
    },
    'search.hos_area_type_id': function () {
        this.hospitalList = this.getHospitalList()
    },
    'search.hos_division_id': function () {
        this.hospitalList = this.getHospitalList()
    },
    'search.hos_district_id': function () {
        this.hospitalList = this.getHospitalList()
    },
    'search.hos_upazila_id': function () {
        this.hospitalList = this.getHospitalList()
    },
    'search.hos_city_corporation_id': function () {
        this.hospitalList = this.getHospitalList()
    },
    'search.hospital_id': function (newVal, oldVal) {
      if (newVal && oldVal !== 0) {
          this.search.department_id = 0
          this.search.hos_ward_id = 0
          const hospital = this.$store.state.HospitalDisabilityService.commonObj.hospitalThirtyPercentList.find(item => item.value === parseInt(newVal))
          this.search.hos_area_type_id = hospital.area_type_id ? hospital.area_type_id : 0
          this.search.hos_division_id = hospital.division_id ? hospital.division_id : 0
          this.search.hos_district_id = hospital.district_id ? hospital.district_id : 0
          this.search.hos_upazila_id = hospital.upazilla_id ? hospital.upazilla_id : 0
          this.search.hos_city_corporation_id = hospital.city_corporation_id ? hospital.city_corporation_id : 0
        }
    }
  },
  methods: {
    tman () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.tman)
      })
      return total
    },
    tmanA () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.tmanA)
      })
      return total
    },
    man () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.man)
      })
      return total
    },
    manA () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.manA)
      })
      return total
    },
    pman () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.pman)
      })
      return total
    },
    pmanA () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.pmanA)
      })
      return total
    },
    twomen () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.twomen)
      })
      return total
    },
    twomenA () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.twomenA)
      })
      return total
    },
    women () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.women)
      })
      return total
    },
    womenA () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.womenA)
      })
      return total
    },
    pwomen () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.pwomen)
      })
      return total
    },
    pwomenA () {
      let total = 0
      this.allData2.map((obj, key) => {
        total = total + parseFloat(obj.pwomenA)
      })
      return total
    },
    getDepartmentName (id) {
      if (id) {
        return this.$store.state.HospitalDisabilityService.commonObj.deptList.filter(dept => dept.value === id)[0].text
      }
    },
    getFiscalYearById (id) {
      const tmp = this.$store.state.commonObj.fiscalYearList.find(item => item.value === id)
      return tmp ? tmp.text : ''
    },
    getMonthById (id) {
      const tmp = this.$store.state.commonObj.monthList.filter(month => month.value === parseInt(id))[0]
      return tmp ? tmp.text : ''
    },
    getYearName (yId) {
      const yearId = parseInt(yId)
      const monthObj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === yearId)
      if (this.search.month_id > 6) {
        return monthObj.text.split('-')[0]
      } else {
        return monthObj.text.split('-')[1]
      }
    },
    getMonthName (mId) {
      const monthId = parseInt(mId)
      const monthObj = this.$store.state.commonObj.monthList.find(item => item.value === monthId)
      return monthObj.text
    },
    getHospitalName (hId) {
      const hospitalId = parseInt(hId)
      const hosObj = this.$store.state.HospitalDisabilityService.commonObj.hospitalThirtyPercentList.find(item => item.value === parseInt(hospitalId))
      if (hosObj) {
          if (this.$i18n.locale === 'en') {
              return hosObj.text_en
          } else {
              return hosObj.text_bn
          }
      } else {
        return ''
      }
    },
    getTotalCount (hId) {
        let m = 0
        let f = 0
        let total = 0
        let male = 0
        let female = 0
        this.allData.map((obj, key) => {
        if (obj.hospital_id === hId) {
            male = obj.man
        }
        })
        if (typeof male !== 'undefined') {
                m = male
        } else {
                m = 0
        }
        this.allData.map((obj, key) => {
          if (obj.hospital_id === hId) {
            female = obj.women
          }
        })
        if (typeof female !== 'undefined') {
              f = female
        } else {
              f = 0
        }
         total = parseInt(m) + parseInt(f)
        return total
    },
    getTTotalCount (hId) {
        let m = 0
        let f = 0
        let total = 0
        let male = 0
        let female = 0
        this.allData.map((obj, key) => {
        if (obj.hospital_id === hId) {
            male = obj.tman
        }
        })
        if (typeof male !== 'undefined') {
                m = male
        } else {
                m = 0
        }
        this.allData.map((obj, key) => {
          if (obj.hospital_id === hId) {
            female = obj.twomen
          }
        })
        if (typeof female !== 'undefined') {
              f = female
        } else {
              f = 0
        }
         total = parseInt(m) + parseInt(f)
        return total
    },
    getPTotalCount (hId) {
        let m = 0
        let f = 0
        let total = 0
        let male = 0
        let female = 0
        this.allData.map((obj, key) => {
        if (obj.hospital_id === hId) {
            male = obj.pman
        }
        })
        if (typeof male !== 'undefined') {
                m = male
        } else {
                m = 0
        }
        this.allData.map((obj, key) => {
          if (obj.hospital_id === hId) {
            female = obj.pwomen
          }
        })
        if (typeof female !== 'undefined') {
              f = female
        } else {
              f = 0
        }
         total = parseInt(m) + parseInt(f)
        return total
    },
    getMaleCount (hId) {
      let male = 0
      this.allData.map((obj, key) => {
        if (obj.hospital_id === hId) {
            male = obj.man
        }
      })
      if (typeof male !== 'undefined') {
                return male
        } else {
                return 0
        }
    },
    getFemaleCount (hId) {
      let female = 0
      this.allData.map((obj, key) => {
         if (obj.hospital_id === hId) {
            female = obj.women
          }
      })
      if (typeof female !== 'undefined') {
              return female
      } else {
              return 0
      }
    },
          getTMaleCount (hId) {
            let male = 0
            this.allData.map((obj, key) => {
              if (obj.hospital_id === hId) {
                  male = obj.tman
              }
            })
            if (typeof male !== 'undefined') {
                      return male
              } else {
                      return 0
              }
          },
          getTFemaleCount (hId) {
            let female = 0
            this.allData.map((obj, key) => {
              if (obj.hospital_id === hId) {
                  female = obj.twomen
                }
            })
            if (typeof female !== 'undefined') {
                    return female
            } else {
                    return 0
            }
          },
                  getPMaleCount (hId) {
                    let male = 0
                    this.allData.map((obj, key) => {
                      if (obj.hospital_id === hId) {
                          male = obj.pman
                      }
                    })
                    if (typeof male !== 'undefined') {
                              return male
                      } else {
                              return 0
                      }
                  },
                  getPFemaleCount (hId) {
                    let female = 0
                    this.allData.map((obj, key) => {
                      if (obj.hospital_id === hId) {
                          female = obj.pwomen
                        }
                    })
                    if (typeof female !== 'undefined') {
                            return female
                    } else {
                            return 0
                    }
                  },
    maleSum (data) {
      let total = 0
      data.map((obj, key) => {
        total = total + parseInt(obj.total_male_patient) + parseInt(obj.free_male_patient) + parseInt(obj.percentage_male_patient)
      })
      return total
    },
    femaleSum (data) {
      let total = 0
      data.map((obj, key) => {
        total = total + parseInt(obj.total_female_patient) + parseInt(obj.free_female_patient) + parseInt(obj.percentage_female_patient)
      })
      return total
    },
    // Component Methods
    viewFile (data) {
      const routeData = hospitalServiceBaseUrl + data
      window.open(routeData, '_blank')
    },
    async getUserWiseHospital (userId) {
        const params = Object.assign({ user_id: userId })
        const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
        if (result.success) {
                this.hospitalIds = result.data
        } else {
              this.$store.state.HospitalDisabilityService.commonObj.hospitalThirtyPercentList.filter(item => item.status === 1).map((obj, key) => {
                  this.hospitalIds.push(obj.value)
              })
        }
        this.loadData()
        this.hospitalList = this.getHospitalList()
    },
    getAreaTypeData (typeId) {
      this.ItemShow = true
      if (typeId === 1) {
          this.CityCorpItemShow = true
          this.PauroshobaItemShow = false
          this.UnionItemShow = false
      } else if (typeId === 2) {
          this.CityCorpItemShow = false
          this.PauroshobaItemShow = true
          this.UnionItemShow = false
      } else if (typeId === 3) {
          this.CityCorpItemShow = false
          this.PauroshobaItemShow = false
          this.UnionItemShow = true
      }
      if (!this.$route.query.id) {
          this.search.city_corporation_id = 0
          this.search.pauroshoba_id = 0
          this.search.ward_id = 0
          this.search.country_id = 1
          this.search.division_id = 0
          this.search.district_id = 0
          this.search.upazilla_id = 0
          this.search.thana_id = 0
          this.search.union_id = 0
        }
    },
    getHospitalList () {
        let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalThirtyPercentList.filter(item => item.is_jointly_formated === 1).filter(item => item.status === 1)
        if (this.hospitalIds.length > 0) {
          hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
        }
        if (this.search.hos_area_type_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.area_type_id === parseInt(this.search.hos_area_type_id))
        }

        if (this.search.category > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.category === this.search.category)
        }

        if (this.search.hos_division_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.division_id === parseInt(this.search.hos_division_id))
        }

        if (this.search.hos_district_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.district_id === parseInt(this.search.hos_district_id))
        }
        if (this.search.hos_city_corporation_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.city_corporation_id === parseInt(this.search.hos_city_corporation_id))
        }
        if (this.search.hos_upazila_id > 0) {
          hospitalList = hospitalList.filter(hospital => hospital.upazilla_id === parseInt(this.search.hos_upazila_id))
        }
        this.hospitalLoad = false
        return hospitalList
    },
    // getHospitalList () {
    //   let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalThirtyPercentList.filter(item => item.status === 1).filter(item => item.is_jointly_formated === 1)
    //   if (this.search.category > 0) {
    //     hospitalList = hospitalList.filter(hospital => hospital.category === this.search.category)
    //   }
    //   return hospitalList
    // },
    searchData () {
      if (this.search.hospital_id > 0) {
        this.loadData2()
      } else {
        this.loadData()
      }
    },
    loadData () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
            const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
            RestApi.getData(hospitalServiceBaseUrl, billingReportApi, params).then(response => {
                if (response.success) {
                    this.allData = response.data
                }
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            })
    },
    loadData2 () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
            const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
            RestApi.getData(hospitalServiceBaseUrl, billingReportHospitalWiseApi, params).then(response => {
                if (response.success) {
                    this.allData2 = response.data
                    this.allData2 = this.allData2.filter(item => item.hospital_id === this.search.hospital_id)
                    this.countIndex = this.allData2.length + 1
                }
                this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
            })
    },
    pdfExport () {
      const data = this.hospitalAllList
      const reportTitle = this.$t('billing_info.billing_info')
      ExportPdf.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, data, this, this.search)
    },
    pdfExport2 () {
      const data = this.allData2
      const reportTitle = this.$t('billing_info.billing_info')
      ExportPdf2.exportPdfDetails(hospitalServiceBaseUrl, 'configuration/report-heading/detail', 3, reportTitle, data, this, this.search)
    }
  }
}
</script>
